const mutations = {
  setRightSidebarCollapsed (state, collapsed) {
    state.ui.view.rightCollapsed = collapsed
  },
  setLeftSidebarCollapsed (state, collapsed) {
    state.ui.view.leftCollapsed = collapsed
  }
}
export default mutations
